import { useTranslation } from "react-i18next";
import type { SummaryResponse } from "../services/workHoursService";

// ---------------------------------------------------------------------------
// Avisos del resumen (#537). El backend puede responder algo distinto de lo que
// se pidió: recorta rangos mayores al máximo (`rangeClamped`), corta la lectura
// al llegar al tope de franjas (`truncated`) o no alcanza a resolver todos los
// títulos de PR (`pullRequestInfoTruncated`). Callarlos deja la pantalla
// diciendo cifras que el usuario cree completas: se avisan, discretos pero
// visibles, junto a los datos que afectan.
// ---------------------------------------------------------------------------

interface Props {
  data: SummaryResponse | null;
  className?: string;
}

export default function SummaryNotices({ data, className = "" }: Props) {
  const { t } = useTranslation("common");
  if (!data) return null;

  const notices: string[] = [];
  if (data.rangeClamped) notices.push(t("workHours.notices.rangeClamped", { from: data.from ?? "—" }));
  if (data.truncated) notices.push(t("workHours.notices.truncated"));
  if (data.pullRequestInfoTruncated) notices.push(t("workHours.notices.pullRequestInfoTruncated"));
  if (notices.length === 0) return null;

  return (
    <div className={`rounded-lg bg-amber-500/10 p-2 text-[11px] text-amber-500 ${className}`} data-testid="summary-notices">
      {notices.map((n) => (
        <p key={n} className="flex items-start gap-1">
          <i className="ri-information-line mt-px" />
          <span>{n}</span>
        </p>
      ))}
    </div>
  );
}
